module.exports = __webpack_public_path__ + "img/home-logo.9b5aa7c.webp";